import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HEIGHT_TRANSITION } from '../../../../modules/animations/animation.constants';
import AnimateHeight from '../../../../modules/animations/components/AnimatedElement/variants/AnimateHeight';
export function getChildrenContent(children, isHovered) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    displayOnTouchScreen = _ref.displayOnTouchScreen,
    isTouchScreenDevice = _ref.isTouchScreenDevice,
    animation = _ref.animation;
  // render content on touch screen device since there is no hover
  if (displayOnTouchScreen && isTouchScreenDevice) {
    return children;
  }

  // render content always to be animated when hovered/unhovered
  if (animation && !isTouchScreenDevice) {
    return children;
  }

  // render content on not a touch screen device and when hovered
  if (!isTouchScreenDevice && isHovered) {
    return children;
  }
  return null;
}
export function getChildrenContainer(animation, animationProps, isHovered) {
  if (animation === HEIGHT_TRANSITION) {
    return /*#__PURE__*/React.createElement(AnimateHeight, _extends({
      height: isHovered ? 'auto' : 0
    }, animationProps || {}));
  }
  return null;
}